import { Typography, type TypographyProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import type { FC } from "react";

interface ITextClamperTypographyProps extends TypographyProps {
  maxLine: number;
}

const PREFIX = "TextClamperTypography";
export const classes = {
  clamp: `${PREFIX}-clamp`,
  text: `${PREFIX}-text`,
};

export const TextClamperTypography = styled<FC<ITextClamperTypographyProps>>(Typography, {
  shouldForwardProp: (prop) => prop !== "maxLine",
})(({ maxLine }) => ({
  [`&.${classes.clamp}`]: {
    overflowWrap: "break-word",
    ...(maxLine === 0 ? { height: 0 } : { WebkitLineClamp: maxLine }),
    WebkitBoxOrient: "vertical",
    display: "-webkit-box",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
}));
